import React from 'react';
import { Row, Col, Typography, Image, Divider } from 'antd';
import PartnerUniversitiesMap from '../../Assets/About/Partner-Universities-Map.png';

const { Title, Paragraph } = Typography;

const universities = [
  'Balochistan University of IT, Engineering and Management Sciences (BUITEMS), Quetta',
  'Sardar Bahadur Khan Women University (SBK), Quetta',
  'Institute of Space Technology (IST), Islamabad',
  'University of Agriculture Faisalabad (UAF), Faisalabad',
  'University of Peshawar (UOP), Peshawar',
  'Shaheed Benazir Bhutto University (SBBU), Sheringal, Dir',
  'University of the Punjab (UOP), Lahore',
];

const PartnerUniversities = () => (
  <section className="partner-universities-section">
    <Row gutter={[64, 40]} justify="space-between" align="middle">
      <Col xs={24} md={15} lg={12}>
        <Title level={2} className="partner-universities-title">Partner Universities</Title>
        <Divider className="ncgsa-divider" />
        <Paragraph className="partner-universities-paragraph">
          NCGSA Research labs are housed at following 7 Higher Education Institutes around Pakistan:
        </Paragraph>
        <ul className="partner-universities-list">
          {universities.map((university) => <li key={university}>{university}</li>)}
        </ul>
      </Col>
      <Col xs={24} md={9} lg={12}>
        <div className="partner-universities-image-container">
          <Image src={PartnerUniversitiesMap} alt="Map of NCGSA partner universities across Pakistan" className="partner-universities-image" preview={false} />
        </div>
      </Col>
    </Row>
  </section>
);

export default PartnerUniversities;
